/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TurniResDto } from '../../models/turni-res-dto';

export interface TurniControllerGetOneEnteById$Params {
  id: number;
}

export function turniControllerGetOneEnteById(
  http: HttpClient,
  rootUrl: string,
  params: TurniControllerGetOneEnteById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<TurniResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    turniControllerGetOneEnteById.PATH,
    'get',
  );
  if (params) {
    rb.path('id', params.id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TurniResDto>;
      }),
    );
}

turniControllerGetOneEnteById.PATH = '/admin/turni/id/{id}';
